// Reconstructed from the supplied production build; original component names were unavailable.
import {
  CalendarIcon,
  CircleCheckBigIcon,
  ClockIcon,
  CreditCardIcon,
  EyeIcon,
  FunnelIcon,
  HashIcon,
  MailIcon,
  PackageIcon,
  PhoneIcon,
  React,
  RefreshCwIcon,
  SearchIcon,
  SquarePenIcon,
  TruckIcon,
  UserIcon,
  XIcon,
  motion,
  useNavigate,
} from "../vendor/runtime.js";
import { api } from "../services/api.js";
import { DeliveryStatusForm } from "../components/DeliveryStatusForm.jsx";
const OrdersPage = () => {
  const [e, t] = React.useState([]),
    [n, r] = React.useState([]),
    [a, l] = React.useState(true),
    [c, d] = React.useState(null),
    [f, h] = React.useState(""),
    [p, g] = React.useState("all"),
    [y, v] = React.useState([]),
    [j, N] = React.useState(false),
    [b, S] = React.useState(null),
    [O, _] = React.useState(false),
    [C, A] = React.useState(null);
  (useNavigate(),
    React.useEffect(() => {
      T();
    }, []),
    React.useEffect(() => {
      M();
    }, [f, p, e]));
  const T = async () => {
      try {
        l(true);
        const F = await api.get("/admin/processing-purchases");
        t(F.data);
        const B = [...new Set(F.data.map((K) => K.delivery_status))].filter(Boolean);
        v(B);
      } catch (F) {
        (console.error("Error fetching orders:", F),
          d("Failed to load orders. Please try again later."));
      } finally {
        l(false);
      }
    },
    M = () => {
      let F = [...e];
      (f &&
        (F = F.filter((B) => {
          var K, Q, ne, L, ee;
          return (
            ((K = B.product_title) == null
              ? undefined
              : K.toLowerCase().includes(f.toLowerCase())) ||
            ((Q = B.user_name) == null ? undefined : Q.toLowerCase().includes(f.toLowerCase())) ||
            ((ne = B.user_email) == null
              ? undefined
              : ne.toLowerCase().includes(f.toLowerCase())) ||
            ((L = B.tracking_no) == null ? undefined : L.toLowerCase().includes(f.toLowerCase())) ||
            ((ee = B.razorpay_order_id) == null
              ? undefined
              : ee.toLowerCase().includes(f.toLowerCase()))
          );
        })),
        p !== "all" && (F = F.filter((B) => B.delivery_status === p)),
        r(F));
    },
    k = (F) => {
      (S(F), N(true));
    },
    $ = (F) => {
      (A(F), _(true));
    },
    I = (F) => {
      const B = e.map((Q) => (Q.purchase_id === F.purchase_id ? F : Q));
      t(B);
      const K = n.map((Q) => (Q.purchase_id === F.purchase_id ? F : Q));
      (r(K), N(false), S(null));
    },
    U = () => {
      (h(""), g("all"));
    },
    q = (F) => {
      switch (F) {
        case "order received":
          return "bg-purple-200 text-purple-900";
        case "in process":
          return "bg-yellow-100 text-yellow-800";
        case "shipped":
          return "bg-purple-100 text-purple-800";
        case "delivered":
          return "bg-green-100 text-green-800";
        default:
          return "bg-gray-100 text-gray-800";
      }
    },
    z = (F) => {
      switch (F) {
        case "order received":
          return <PackageIcon className={"w-3 h-3 mr-1"} />;
        case "in process":
          return <RefreshCwIcon className={"w-3 h-3 mr-1"} />;
        case "shipped":
          return <TruckIcon className={"w-3 h-3 mr-1"} />;
        case "delivered":
          return <CircleCheckBigIcon className={"w-3 h-3 mr-1"} />;
        default:
          return <ClockIcon className={"w-3 h-3 mr-1"} />;
      }
    },
    Y = {
      hidden: {
        opacity: 0,
        y: 20,
      },
      visible: {
        opacity: 1,
        y: 0,
        transition: {
          duration: 0.4,
        },
      },
    };
  return a && e.length === 0 ? (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <div className={"flex items-center justify-center h-screen"}>
        <div className={"p-8 flex flex-col items-center"}>
          <div className={"w-16 h-16 relative"}>
            <div
              className={
                "absolute inset-0 rounded-full border-t-4 border-b-4 border-purple-600 animate-spin"
              }
            />
            <div
              className={
                "absolute inset-0 rounded-full border-r-4 border-l-4 border-purple-700 animate-pulse opacity-75"
              }
            />
          </div>
          <p className={"mt-4 text-gray-600"}>{"Loading orders..."}</p>
        </div>
      </div>
    </div>
  ) : (
    <div className={"admin-page bg-gradient-to-br from-purple-50 to-purple-100"}>
      <main className="admin-main">
        <motion.div initial={"hidden"} animate={"visible"} variants={Y} className={"mb-8"}>
          <h1 className={"text-3xl font-bold text-gray-900 mb-2"}>{"Orders Management"}</h1>
          <p className={"text-gray-600"}>{"Manage processing orders and update delivery status"}</p>
        </motion.div>
        {c && (
          <motion.div initial={"hidden"} animate={"visible"} variants={Y} className={"mb-6"}>
            <div
              className={"bg-red-100 border-l-4 border-red-500 text-red-700 p-4 rounded-md"}
              role={"alert"}
            >
              <p className={"font-medium"}>{"Error"}</p>
              <p>{c}</p>
            </div>
          </motion.div>
        )}
        <motion.div initial={"hidden"} animate={"visible"} variants={Y} className={"mb-6"}>
          <div className={"bg-white p-4 rounded-xl shadow-sm"}>
            <div className={"flex flex-col md:flex-row justify-between gap-4"}>
              <div className={"w-full md:w-1/3"}>
                <div className={"relative"}>
                  <div
                    className={
                      "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                    }
                  >
                    <SearchIcon className={"h-5 w-5 text-gray-400"} />
                  </div>
                  <input
                    type={"text"}
                    placeholder={"Search by product, customer, tracking, or order ID"}
                    className={
                      "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                    }
                    value={f}
                    onChange={(F) => h(F.target.value)}
                  />
                </div>
              </div>
              <div className={"flex flex-col sm:flex-row gap-4"}>
                <div className={"w-full sm:w-auto"}>
                  <div className={"relative"}>
                    <div
                      className={
                        "absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none"
                      }
                    >
                      <FunnelIcon className={"h-5 w-5 text-gray-400"} />
                    </div>
                    <select
                      className={
                        "pl-10 pr-4 py-2 border border-gray-300 rounded-lg focus:ring-purple-500 focus:border-purple-500 block w-full"
                      }
                      value={p}
                      onChange={(F) => g(F.target.value)}
                    >
                      <option value={"all"}>{"All Statuses"}</option>
                      {y.map((F, B) => (
                        <option key={B} value={F}>
                          {F.charAt(0).toUpperCase() + F.slice(1)}
                        </option>
                      ))}
                    </select>
                  </div>
                </div>
                <button
                  onClick={U}
                  className={
                    "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50 flex items-center"
                  }
                >
                  <XIcon className={"h-5 w-5 mr-2"} />
                  {"Clear Filters"}
                </button>
                <button
                  onClick={T}
                  className={
                    "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  }
                >
                  <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                  {"Refresh"}
                </button>
              </div>
            </div>
          </div>
        </motion.div>
        <motion.div initial={"hidden"} animate={"visible"} variants={Y}>
          {n.length > 0 ? (
            <div className={"bg-white rounded-2xl shadow-lg overflow-hidden"}>
              <div className={"overflow-x-auto"}>
                <table className={"min-w-full divide-y divide-gray-200"}>
                  <thead>
                    <tr>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Order Details"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Customer"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Product & Amount"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Delivery Status"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Shipping Info"}
                      </th>
                      <th
                        scope={"col"}
                        className={
                          "px-6 py-4 text-left text-xs font-medium text-gray-500 uppercase tracking-wider bg-gray-50"
                        }
                      >
                        {"Actions"}
                      </th>
                    </tr>
                  </thead>
                  <tbody className={"bg-white divide-y divide-gray-200"}>
                    {n.map((F) => (
                      <tr
                        key={F.purchase_id}
                        className={"hover:bg-gray-50 transition duration-150"}
                      >
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"flex items-center"}>
                            <div
                              className={
                                "flex-shrink-0 h-10 w-10 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center text-white font-bold"
                              }
                            >
                              <HashIcon className={"h-5 w-5"} />
                            </div>
                            <div className={"ml-4"}>
                              <div className={"text-sm font-medium text-gray-900"}>
                                {"Order #"}
                                {F.purchase_id}
                              </div>
                              <div className={"text-xs text-gray-500 flex items-center"}>
                                <CalendarIcon className={"w-3 h-3 mr-1"} />
                                {F.purchase_date
                                  ? new Date(F.purchase_date).toLocaleDateString()
                                  : "N/A"}
                              </div>
                              <div className={"text-xs text-gray-500"}>
                                {"Payment ID: "}
                                {F.razorpay_payment_id || "N/A"}
                              </div>
                            </div>
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"flex items-center"}>
                            <div
                              className={
                                "flex-shrink-0 h-8 w-8 bg-gray-100 rounded-full flex items-center justify-center"
                              }
                            >
                              <UserIcon className={"h-4 w-4 text-gray-500"} />
                            </div>
                            <div className={"ml-3"}>
                              <div className={"text-sm font-medium text-gray-900"}>
                                {F.user_name || "Unknown"}
                              </div>
                              <div className={"text-xs text-gray-500 flex items-center"}>
                                <MailIcon className={"w-3 h-3 mr-1"} />
                                {F.user_email || "N/A"}
                              </div>
                              {F.user_phone && (
                                <div className={"text-xs text-gray-500 flex items-center"}>
                                  <PhoneIcon className={"w-3 h-3 mr-1"} />
                                  {F.user_phone}
                                </div>
                              )}
                            </div>
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"text-sm font-medium text-gray-900"}>
                            {F.product_title || "Unnamed Product"}
                          </div>
                          <div className={"text-sm text-gray-500 flex items-center"}>
                            <CreditCardIcon className={"w-3 h-3 mr-1"} />
                            {"₹"}
                            {typeof F.product_amount == "number" ||
                            typeof F.product_amount == "string"
                              ? parseFloat(F.product_amount).toFixed(2)
                              : "0.00"}
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <span
                            className={`px-3 py-1 inline-flex text-xs leading-5 font-semibold rounded-full items-center ${q(F.delivery_status)}`}
                          >
                            {z(F.delivery_status)}
                            {F.delivery_status
                              ? F.delivery_status.charAt(0).toUpperCase() +
                                F.delivery_status.slice(1)
                              : "Unknown"}
                          </span>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap"}>
                          <div className={"text-sm text-gray-900"}>
                            {F.shipping_company ? (
                              <div className={"flex items-center"}>
                                <TruckIcon className={"w-3 h-3 mr-1 text-gray-400"} />
                                {F.shipping_company}
                              </div>
                            ) : (
                              <span className={"text-gray-400"}>{"Not assigned"}</span>
                            )}
                          </div>
                          <div className={"text-xs text-gray-500"}>
                            {F.tracking_no ? (
                              <span>
                                {"Tracking: "}
                                {F.tracking_no}
                              </span>
                            ) : (
                              <span>{"No tracking number"}</span>
                            )}
                          </div>
                        </td>
                        <td className={"px-6 py-4 whitespace-nowrap text-sm font-medium"}>
                          <div className={"flex space-x-2"}>
                            <button
                              onClick={() => $(F)}
                              className={
                                "p-2 bg-purple-100 text-purple-800 rounded-lg hover:bg-purple-200 transition-colors flex items-center"
                              }
                              title={"View Details"}
                            >
                              <EyeIcon className={"h-4 w-4"} />
                            </button>
                            <button
                              onClick={() => k(F)}
                              className={
                                "p-2 bg-purple-50 text-purple-600 rounded-lg hover:bg-purple-100 transition-colors flex items-center"
                              }
                              title={"Update Delivery Status"}
                            >
                              <SquarePenIcon className={"h-4 w-4"} />
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </tbody>
                </table>
              </div>
            </div>
          ) : (
            <div className={"bg-white rounded-2xl shadow-lg p-12 text-center"}>
              <div className={"flex flex-col items-center justify-center"}>
                <div
                  className={
                    "w-24 h-24 bg-gray-100 rounded-full flex items-center justify-center text-gray-400 mb-6"
                  }
                >
                  <PackageIcon className={"h-12 w-12"} />
                </div>
                <h3 className={"text-xl font-bold text-gray-800 mb-2"}>{"No Orders Found"}</h3>
                <p className={"text-gray-500 mb-6"}>
                  {f || p !== "all"
                    ? "No orders match your filters. Try adjusting your search criteria."
                    : "There are no processing orders in the system yet."}
                </p>
                <button
                  onClick={U}
                  className={
                    "px-4 py-2 bg-purple-600 text-white rounded-lg hover:bg-purple-700 flex items-center"
                  }
                >
                  <RefreshCwIcon className={"h-5 w-5 mr-2"} />
                  {f || p !== "all" ? "Clear Filters" : "Refresh"}
                </button>
              </div>
            </div>
          )}
        </motion.div>
      </main>
      {O && C && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div
            className={"bg-white rounded-lg shadow-xl  w-full p-6 m-4 max-h-[90vh] overflow-y-auto"}
          >
            <div className={"flex justify-between items-center mb-6"}>
              <h3 className={"text-lg font-bold text-gray-900"}>{"Order Details"}</h3>
              <button onClick={() => _(false)} className={"text-gray-400 hover:text-gray-500"}>
                <XIcon className={"h-6 w-6"} />
              </button>
            </div>
            <div className={"space-y-6"}>
              <div className={"bg-gray-50 p-4 rounded-lg"}>
                <h4 className={"font-semibold text-gray-800 mb-3"}>{"Order Information"}</h4>
                <div className={"grid grid-cols-2 gap-4 text-sm"}>
                  <div>
                    <span className={"text-gray-500"}>{"Order ID:"}</span>
                    <p className={"font-medium"}>
                      {"#"}
                      {C.purchase_id}
                    </p>
                  </div>
                  <div>
                    <span className={"text-gray-500"}>{"Order Date:"}</span>
                    <p className={"font-medium"}>
                      {C.purchase_date ? new Date(C.purchase_date).toLocaleDateString() : "N/A"}
                    </p>
                  </div>
                  <div>
                    <span className={"text-gray-500"}>{"Payment Status:"}</span>
                    <p className={"font-medium"}>{C.status || "N/A"}</p>
                  </div>
                  <div>
                    <span className={"text-gray-500"}>{"Razorpay Order ID:"}</span>
                    <p className={"font-medium"}>{C.razorpay_order_id || "N/A"}</p>
                  </div>
                  <div className={"col-span-2"}>
                    <span className={"text-gray-500"}>{"Razorpay Payment ID:"}</span>
                    <p className={"font-medium"}>{C.razorpay_payment_id || "N/A"}</p>
                  </div>
                </div>
              </div>
              <div className={"bg-gray-50 p-4 rounded-lg"}>
                <h4 className={"font-semibold text-gray-800 mb-3"}>{"Product Information"}</h4>
                <div className={"text-sm"}>
                  <div className={"mb-2"}>
                    <span className={"text-gray-500"}>{"Product:"}</span>
                    <p className={"font-medium"}>{C.product_title || "Unnamed Product"}</p>
                  </div>
                  <div>
                    <span className={"text-gray-500"}>{"Amount:"}</span>
                    <p className={"font-medium"}>
                      {"₹"}
                      {typeof C.product_amount == "number" || typeof C.product_amount == "string"
                        ? parseFloat(C.product_amount).toFixed(2)
                        : "0.00"}
                    </p>
                  </div>
                </div>
              </div>
              <div className={"bg-gray-50 p-4 rounded-lg"}>
                <h4 className={"font-semibold text-gray-800 mb-3"}>{"Customer Information"}</h4>
                <div className={"text-sm"}>
                  <div className={"mb-2"}>
                    <span className={"text-gray-500"}>{"Name:"}</span>
                    <p className={"font-medium"}>{C.user_name || "Unknown"}</p>
                  </div>
                  <div className={"mb-2"}>
                    <span className={"text-gray-500"}>{"Email:"}</span>
                    <p className={"font-medium"}>{C.user_email || "N/A"}</p>
                  </div>
                  <div className={"mb-2"}>
                    <span className={"text-gray-500"}>{"Phone:"}</span>
                    <p className={"font-medium"}>{C.user_phone || "N/A"}</p>
                  </div>
                  <div>
                    <span className={"text-gray-500"}>{"Address:"}</span>
                    <p className={"font-medium"}>{C.user_address || "N/A"}</p>
                  </div>
                </div>
              </div>
              <div className={"bg-gray-50 p-4 rounded-lg"}>
                <h4 className={"font-semibold text-gray-800 mb-3"}>{"Shipping Information"}</h4>
                <div className={"text-sm"}>
                  <div className={"mb-2"}>
                    <span className={"text-gray-500"}>{"Delivery Status:"}</span>
                    <span
                      className={`ml-2 px-2 py-1 text-xs font-semibold rounded-full ${q(C.delivery_status)}`}
                    >
                      {C.delivery_status
                        ? C.delivery_status.charAt(0).toUpperCase() + C.delivery_status.slice(1)
                        : "Unknown"}
                    </span>
                  </div>
                  <div className={"mb-2"}>
                    <span className={"text-gray-500"}>{"Shipping Company:"}</span>
                    <p className={"font-medium"}>{C.shipping_company || "Not assigned"}</p>
                  </div>
                  <div>
                    <span className={"text-gray-500"}>{"Tracking Number:"}</span>
                    <p className={"font-medium"}>{C.tracking_no || "Not assigned"}</p>
                  </div>
                </div>
              </div>
            </div>
            <div className={"flex justify-end mt-6"}>
              <button
                onClick={() => _(false)}
                className={
                  "px-4 py-2 border border-gray-300 rounded-lg text-gray-700 hover:bg-gray-50"
                }
              >
                {"Close"}
              </button>
            </div>
          </div>
        </div>
      )}
      {j && b && (
        <div
          className={"fixed inset-0 bg-black/50 flex items-center justify-center z-50"}
        >
          <div className={"bg-white rounded-lg shadow-xl  w-full p-6 m-4"}>
            <div className={"flex justify-between items-center mb-4"}>
              <h3 className={"text-lg font-bold text-gray-900"}>{"Update Delivery Status"}</h3>
              <button onClick={() => N(false)} className={"text-gray-400 hover:text-gray-500"}>
                <XIcon className={"h-6 w-6"} />
              </button>
            </div>
            <div className={"mb-4 bg-gray-50 p-4 rounded-lg"}>
              <div className={"flex items-center"}>
                <div
                  className={
                    "flex-shrink-0 h-10 w-10 bg-gradient-to-br from-purple-500 to-purple-700 rounded-lg flex items-center justify-center text-white font-bold"
                  }
                >
                  <HashIcon className={"h-5 w-5"} />
                </div>
                <div className={"ml-4"}>
                  <div className={"text-sm font-medium text-gray-900"}>
                    {"Order #"}
                    {b.purchase_id}
                  </div>
                  <div className={"text-xs text-gray-500"}>{b.product_title}</div>
                  <div className={"text-xs text-gray-500"}>
                    {"Customer: "}
                    {b.user_name}
                  </div>
                </div>
              </div>
            </div>
            <DeliveryStatusForm order={b} onUpdate={I} />
          </div>
        </div>
      )}
    </div>
  );
};
export { OrdersPage };
